import React from 'react';
import Carousel from 'react-material-ui-carousel'
import { Paper, Button, Card, CardMedia, Grid } from '@mui/material'
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { useStore } from '../../../state/MobxContext';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import Box from '@mui/material/Box';
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { useEffect } from 'react';


function CouponCard(props) {

  // console.log("props", props);
  const { SaleStore } = useStore();




  const useStyles = makeStyles((theme) => ({
    //BrandImage
    BrandImage: {
      // whiteSpace: "nowrap",
      // objectFit: "cover",
      width: '100%',
      height: "8rem"
    },
    //BrandiamgeSlide
    BrandiamgeSlide: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }));

  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");

  // let Description = props.item.description;


  const BrandTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.8rem',
        alignItems: 'center',
        justifyContent: "center"
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1rem',
        alignItems: 'center',
        justifyContent: "center"
      }
  })(Typography);

  const GoodsNameTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.7rem',
        alignItems: 'center',
        justifyContent: "center"
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1rem',
        alignItems: 'center',
        justifyContent: "center"
      }
  })(Typography);


  // console.log("Prrr", props);



  return (
    <Card key={props.item.Index}
      sx={isMobile ? { bgcolor: "black", maxWidth: 90, m: "0.2rem", boxShadow: 10, marginBottom: "1rem" } : { bgcolor: "black", maxWidth: 200, m: 2, boxShadow: 10 }} >
      <Grid container direction='row' justifyContent='center' alignItems='center'
        sx={{ bgcolor: props.item.member_use === "N" ? "#3BBD4C" : "red" }}
        onClick={() => { SaleStore?.setCouponitemPage(props.item) }}
      >
        <BrandTypographyMobile>
          {props.item.member_use === "N" && "사용 가능"}
          {props.item.member_use === "Y" && "사용"}
          {props.item.member_use === "C" && "취소"}
        </BrandTypographyMobile>
      </Grid>
      <CardMedia
        component="img"
        sx={isMobile ? { height: 90 } : { height: 170 }}
        image={props.item.image}
        alt={props.item.goods_name}
        onClick={() => { SaleStore?.setCouponitemPage(props.item) }}
      />
      <Grid container direction='row' justifyContent='center' alignItems='center'
        onClick={() => { SaleStore?.setCouponitemPage(props.item) }}
      >
        <GoodsNameTypographyMobile>
          {props.item.goods_name}
          <br />
          {/* {props.item.description}
          <br /> */}
          {props.item.member_exdate}

        </GoodsNameTypographyMobile>
      </Grid>
    </Card>
  )
}

export default observer(CouponCard);
